import React, { useRef, useContext } from 'react';

import { useDay } from '@datepicker-react/hooks';
import cn from 'clsx';

import DatepickerContext from './context';

function Day({ day, date }) {
  const dayRef = useRef(null);
  const {
    focusedDate,
    isDateFocused,
    isDateSelected,
    isDateHovered,
    isDateBlocked,
    isFirstOrLastSelectedDate,
    onDateSelect,
    onDateFocus,
    onDateHover,
  } = useContext(DatepickerContext);
  const {
    isSelected,
    isSelectedStartOrEnd,
    onClick,
    onKeyDown,
    onMouseEnter,
    tabIndex,
  } = useDay({
    date,
    focusedDate,
    isDateFocused,
    isDateSelected,
    isDateHovered,
    isDateBlocked,
    isFirstOrLastSelectedDate,
    onDateFocus,
    onDateSelect,
    onDateHover,
    dayRef,
  });

  if (!day) {
    return <div />;
  }

  const rootCn = cn(
    'tracking-wider py-2 md:py-3 font-display hover:underline',
    {
      'text-white bg-magenta': isSelected || isSelectedStartOrEnd,
      'text-gray-700 bg-white hover:bg-gray-100': !(
        isSelected || isSelectedStartOrEnd
      ),
    }
  );

  return (
    <button
      className={rootCn}
      onClick={onClick}
      onKeyDown={onKeyDown}
      onMouseEnter={onMouseEnter}
      tabIndex={tabIndex}
      type="button"
      ref={dayRef}
    >
      {day}
    </button>
  );
}

export default React.memo(Day);
